import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Header } from '@/components/layout/Header'
import { Button, Input, Avatar } from '@/components/ui'
import { useAuthStore } from '@/store/authStore'
import { organizationsApi } from '@/api/organizationsApi'
import apiClient from '@/api/client'
import type { User } from '@/types'
import { toast } from '@/components/ui/Toast'

export function ProfilePage() {
  const user = useAuthStore(s => s.user)
  return <><Header title="Профиль" subtitle="Ваши данные и текущий клуб" />{user && <ProfileForm key={user.id} user={user} />}</>
}
function ProfileForm({ user }: { user: User }) {
  const client = useQueryClient()
  const [name, setName] = useState(user.name)
  const clubs = useQuery({ queryKey: ['desktop-clubs'], queryFn: organizationsApi.getMyOrganizations })
  const club = clubs.data?.find(c => c.id === user.selected_organization_id) ?? clubs.data?.[0]
  const save = useMutation({ mutationFn: async () => apiClient.put(`/users/${user.id}`, { name: name.trim() }),
    onSuccess: async () => { await client.invalidateQueries({ queryKey: ['desktop-me'] }); toast.success('Профиль сохранён') }, onError: () => toast.error('Имя не сохранено. Повторите попытку'),
  })
  return <div className="pc-page"><section className="pc-panel max-w-3xl"><div className="flex gap-4 items-center mb-6"><Avatar name={user.name} size={56} /><div><h2 className="pc-section-title">{user.name}</h2><p className="pc-muted mt-1">{user.email || 'Email не привязан'}</p></div></div>
    <form className="space-y-5 max-w-lg" onSubmit={e => { e.preventDefault(); save.mutate() }}><Input label="Имя" value={name} onChange={e => setName(e.target.value)} required disabled={save.isPending} /><div><p className="pc-muted">Текущий клуб</p><p className="font-medium mt-1">{club?.name || 'Клуб не выбран'}</p></div><Button loading={save.isPending} disabled={!name.trim() || name.trim() === user.name}>Сохранить имя</Button></form>
  </section></div>
}
